import { render, staticRenderFns } from "./TopSellingModel.vue?vue&type=template&id=5050e0e4"
import script from "./TopSellingModel.vue?vue&type=script&lang=js"
export * from "./TopSellingModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports